import {useCallback, useEffect, useState} from "react";

export const useOTP = (callBack) => {
    const [abortController, setAbortController] = useState(null);
    useEffect(() => {
        if ("OTPCredential" in window) {
            const ac = new AbortController();
            setAbortController(ac);
            // Request the OTP via get()
            navigator.credentials
                .get({
                    otp: {transport: ["sms"]},
                    signal: ac.signal,
                })
                .then((otp) => {
                    // When the OTP is received by the app client, enter it into the form
                    // input and submit the form automatically
                    callBack(otp.code)
                })
                .catch((err) => {
                    console.error(err);
                });
            return ()=>{
                ac.abort();
            }
        }
    }, []);
    const close = useCallback(() => {
        if (abortController) {
            abortController.abort()
        }
    }, [abortController]);
    return [close]
}